
define(['jquery', 'require', 'underscore', 'underscore.string', 'backbone', 'core', 'app-common/menu-builder', 'app-common/template/dialog.htm'], function($, require, _, _s, Backbone, core, menuBuilder, dialogTemplate) {
  var currentPage, loadTab;
  currentPage = null;
  loadTab = function(id) {
    if (currentPage != null) {
      currentPage.remove();
    }
    return currentPage = new (require('app-client/page/' + id))({
      dialog: true
    }, []);
  };
  return {
    init: function(dialogId) {
      var clientModel, data, dialog, tabs;
      data = _.findWhere(core.getConfig().dialogs, {
        id: dialogId
      });
      if (!data || data.tabs.length === 0) {
        return;
      }
      clientModel = core.getCurrentClient() || {};
      tabs = _.filter(data.tabs, function(tab) {
        return !tab.hide || (tab.hide && !tab.hide(clientModel));
      });
      $('body').append(_.template(dialogTemplate, {
        tabs: tabs
      }));
      dialog = $('#dialog-window');
      if (data.hideHeader) {
        dialog.find('.dialog-header').hide();
      }
      loadTab(tabs[0].id);
      dialog.modal().on('hidden', function() {
        dialog.show();
        dialog.removeClass('dialog-visible');
        return setTimeout(function() {
          return dialog.remove();
        }, 300);
      });
      dialog.find('.dialog-tab:first').tab('show');
      dialog.find('.dialog-item').on('click', function() {
        loadTab($(this).data('id'));
        return $(this).find('.dialog-tab').tab('show');
      });
      return dialog.addClass('dialog-visible');
    },
    showTab: function(id) {
      loadTab(id);
      return $(".dialog-item[data-id='" + id + "']").tab('show');
    }
  };
});
